/**
 * Origem Flow: cor semântica de datas (estilo ClickUp) — campos de data cujo
 * nome indica vencimento ficam vermelhos quando a data é hoje ou já passou.
 * Mesma abordagem de heurística por nome usada no restante do fork.
 */
const DUE_FIELD_NAMES = new Set([
  'data de vencimento',
  'vencimento',
  'due date',
  'due',
  'prazo',
  'deadline',
  'entrega',
  'data de entrega',
  'data limite',
  'data de término estimada',
  'término estimado',
  'termino estimado',
  'fim previsto',
  'data prevista',
])

function localTodayString() {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}

// Mesma heurística do backend (HomeTableCountsView): campo de status e
// opções consideradas "fechadas".
const STATUS_FIELD_NAMES = new Set([
  'status',
  'situação',
  'situacao',
  'estado',
  'etapa',
])

const DONE_OPTION_VALUES = new Set([
  'concluído',
  'concluido',
  'feito',
  'done',
  'completed',
  'completo',
  'cancelado',
  'cancelled',
  'canceled',
  'fechado',
  'closed',
  'arquivado',
  'archived',
])

export function isDueDateField(field) {
  return DUE_FIELD_NAMES.has((field.name || '').trim().toLowerCase())
}

/**
 * Verdadeiro quando o single select de status da linha aponta para uma
 * opção fechada (Concluído, Cancelado...). O campo de status é o primeiro
 * single select com nome de status, ou o primeiro single select da tabela.
 */
export function isRowDone(row, fields) {
  if (!row || !Array.isArray(fields)) {
    return false
  }
  const statusField = getStatusField(fields)
  if (statusField === null) {
    return false
  }
  return isDoneOption(row[`field_${statusField.id}`])
}

/**
 * O campo de status da tabela: o primeiro single select com nome de status,
 * ou o primeiro single select existente. Null quando a tabela não tem.
 */
export function getStatusField(fields) {
  if (!Array.isArray(fields)) {
    return null
  }
  let statusField = null
  for (const field of fields) {
    if (field.type !== 'single_select') {
      continue
    }
    if (STATUS_FIELD_NAMES.has((field.name || '').trim().toLowerCase())) {
      return field
    }
    if (statusField === null) {
      statusField = field
    }
  }
  return statusField
}

/**
 * Verdadeiro quando a opção de single select representa um status fechado
 * (Concluído, Cancelado...).
 */
export function isDoneOption(option) {
  return (
    !!option &&
    DONE_OPTION_VALUES.has((option.value || '').trim().toLowerCase())
  )
}

export function isDueDateOverdue(field, value) {
  if (!value || !isDueDateField(field)) {
    return false
  }
  if (field.date_include_time) {
    const date = new Date(value)
    return !isNaN(date) && date.getTime() <= Date.now()
  }
  return String(value).slice(0, 10) <= localTodayString()
}
